<div class="form-group" [class.has-error]="!!errors()">
  @for (control of formArray.controls; track control; let i = $index) {
    <div
        [class.input--filled]="!!control.value">
      <label class="control-label tw-flex tw-items-center tw-gap-spacing-25" [htmlFor]="controlName() + '_' + i">
        {{ schemaTranslations()?.getFieldTranslation(controlName()) }}
        @if (properties() | propertyIsFieldRequired:controlName()) {
          <span class="required with-hint">*</span>
        }
        @if (properties() | showPropertyArrayHint: controlName()) {
          <app-hint
              [tooltipText]="(properties() | propertyArrayHintText: controlName()) | translate:(properties() | propertyGetFields:controlName())"/>
        }
      </label>
      <select [formControl]="$any(control)"
              class="form-control"
              [id]="controlName() + '_' + i">
        <option value="">{{ 'generic.default_select_value' | translate }}</option>
        @for (enumValue of properties() | propertyGetEnumValues:controlName(); track enumValue) {
          <option [value]="enumValue">
            {{ (properties() | propertyHasNumericValues:controlName()) ? enumValue : schemaTranslations()?.getEnumTranslation(controlName(), enumValue) }}
          </option>
        }
      </select>
    </div>
  }
  @if (showPlus()) {
    <span (click)="addFormControl()">
      <a class="btn-circle"><i class="icon icon-plus-square"></i></a>
      <label class="btn-circle-label">{{ schemaTranslations()?.getFieldTranslation(controlName()) }}</label>
    </span>
  }
</div>
